import { SequenceMenu } from '@sequencehq/core-components'
import { IntegrationServices } from '@sequencehq/api'
import { integrationName } from 'lib/integrations/integrationName'
import { getLogo } from 'lib/integrations/logos'

export const UnlinkCustomerMenuItem = (props: {
  customerId: string
  service: IntegrationServices
  onSelect: () => void
  onMenuClose?: () => void
}) => {
  return (
    <SequenceMenu.Item
      uuid={`unlink-${props.service}`}
      label={`Unlink from ${integrationName(props.service)}`}
      iconRight={getLogo(props.service, 18)}
      data-testid={`customers.${props.customerId}.menuItem.unlinkFrom${props.service}`}
      onClick={() => {
        props.onSelect()
        props.onMenuClose?.()
      }}
    />
  )
}
